import { FormControlLabel, SwitchProps } from "@mui/material";
import React from "react";
import MySwitch from "../switch";
import "./switch.css";

const MySwitchField = ({
  label,
  labelPlacement,
  sx,
  ...props
}: {
  label?: string | React.ReactNode;
  labelPlacement?: "bottom" | "top" | "end" | "start";
  sx?: any;
} & SwitchProps) => {
  return (
    <FormControlLabel
      control={
        <MySwitch
          {...(props.checked === undefined ? { defaultChecked: true } : {})}
          {...props}
        />
      }
      label={label}
      sx={{
        alignItems: "flex-start",
        marginLeft: "0px",
        ...sx,
      }}
      labelPlacement={labelPlacement ?? "top"}
    />
  );
};

export default MySwitchField;
